<script lang="ts">
  import type { Snippet } from 'svelte';
  import Container from '$components/News/Container.svelte';
  import FullWidthContainer from '$components/News/FullWidthContainer.svelte';

  interface Props {
    fullWidth?: boolean | undefined;
    carousel?: Snippet;
    caption?: Snippet;
  }

  let { fullWidth = undefined, carousel, caption }: Props = $props();
</script>

{#if fullWidth}
  <FullWidthContainer>
    {@render carousel?.()}
  </FullWidthContainer>
  <Container>
    {@render caption?.()}
  </Container>
{:else}
  {@render carousel?.()}
  {@render caption?.()}
{/if}
